import { useTranslation } from 'react-i18next'

export const ErrorMaintenance = () => {
  const { t } = useTranslation()

  return (
    <div className="loading-page">
      <h1>{t('maintenanceModeTitle')}</h1>
    </div>
  )
}
